import React, { useContext, useState } from "react"
import { MasterButton, Modal, ModalDeleteConfirm } from "App/Component/ui"
import { DISABLED_BUTTON_SUBMIT, instance3 } from "App/constants"
import { urlAddTagihan } from "."
import { FormContext } from "../context/FormContext"
import {
  defaultToastError,
  toUTCFormat,
  defaultToastSuccess,
  isNull,
  scrollToTop,
} from "App/utils/helpers"

import {
  STATUS_TRANSAKSI_REAKP_TAGIHAN_BUKA,
  STATUS_TRANSAKSI_REAKP_TAGIHAN_KUNCI,
  STATUS_TRANSAKSI_REAKP_TAGIHAN_TUTUP,
  validationInputRekapTagihan,
} from "./helpers"

import {
  SHOW_BUKA_TRANSAKSI,
  SHOW_KUNCI_TRANSAKSI,
  SHOW_BUKA_KUNCI_TRANSAKSI,
  SHOW_UPDATE_TRANSAKSI,
  SHOW_TUTUP_TRANSAKSI,
  SHOW_BUKA_TUTUP_TRANSAKSI,
} from "utils/billing"

const ModalSimpan = ({ setShowModal }) => {
  const { formData, setFormData, setFormError, rowsTagihan, rowsPembayaran } =
    useContext(FormContext)

  return (
    <Modal title={"Simpan"} show={setShowModal} width="20%">
      <ButtonActionBukaTransaksi
        formData={formData}
        setFormData={setFormData}
        setFormError={setFormError}
        setShowModal={setShowModal}
      />

      <ButtonActionUpdateTransaksi
        formData={formData}
        setFormData={setFormData}
        setFormError={setFormError}
        setShowModal={setShowModal}
      />

      <ButtonActionKunciTransaksi
        formData={formData}
        setFormData={setFormData}
        setFormError={setFormError}
        setShowModal={setShowModal}
        rowsTagihan={rowsTagihan}
      />

      <ButtonActionBukaKembaliTransaksi
        formData={formData}
        setFormData={setFormData}
        setFormError={setFormError}
        setShowModal={setShowModal}
      />

      <ButtonActionTutupTransaksi
        formData={formData}
        setFormData={setFormData}
        setFormError={setFormError}
        setShowModal={setShowModal}
        rowsPembayaran={rowsPembayaran}
      />

      <ButtonActionBukaTutupTransaksi
        formData={formData}
        setFormData={setFormData}
        setFormError={setFormError}
        setShowModal={setShowModal}
      />
    </Modal>
  )
}

export default ModalSimpan

const ButtonActionBukaTransaksi = ({
  formData,
  setFormData,
  setFormError,
  setShowModal,
}) => {
  const [disabledBukaTransaksi, setDisabledBukaTransaksi] =
    useState(SHOW_BUKA_TRANSAKSI)

  const handleClickBukaTransaksi = async () => {
    setDisabledBukaTransaksi(DISABLED_BUTTON_SUBMIT)
    try {
      const errors = validationInputRekapTagihan(formData)
      if (Object.keys(errors).length === 0) {
        const api = await instance3.post(urlAddTagihan, {
          instalasi_id: formData.jenis_rawat_id,
          company_id: formData.company_id,
          penerima: formData.jenis_asuransi_id,
          asuransi_id: formData.asuransi_id,
          tanggal: toUTCFormat(formData.tanggal_rekap),
          tanggal_periode_awal: toUTCFormat(formData.tanggal_periode_awal),
          tanggal_periode_akhir: toUTCFormat(formData.tanggal_periode_akhir),
          tanggal_tagih: toUTCFormat(formData.tanggal_tagih),
          tanggal_jatuh_tempo: toUTCFormat(formData.tanggal_jatuh_tempo),
          no_resi: formData.no_resi,
        })
        const res = api.data
        if (res.status === 200) {
          setFormData({
            ...formData,
            rekap_tagihan_id: res.body.id,
            no_surat: res.body.no_surat,
            status_proses: STATUS_TRANSAKSI_REAKP_TAGIHAN_BUKA,
          })
          defaultToastSuccess("Berhasil Menyimpan Data")
          setDisabledBukaTransaksi(SHOW_BUKA_TRANSAKSI)
          setFormError(null)
          setShowModal(false)
        } else {
          setDisabledBukaTransaksi(SHOW_BUKA_TRANSAKSI)
          defaultToastError(res.data.message)
        }
      } else {
        scrollToTop()
        setFormError(errors)
        setDisabledBukaTransaksi(SHOW_BUKA_TRANSAKSI)
        setShowModal(false)
      }
    } catch (error) {
      setDisabledBukaTransaksi(SHOW_BUKA_TRANSAKSI)
      defaultToastError(error?.response?.data?.message)
    }
  }

  if (formData.status_proses === null) {
    return (
      <>
        <MasterButton
          className={"mt-1 w-full text-center"}
          type={"button"}
          color={disabledBukaTransaksi.color}
          name={disabledBukaTransaksi.label}
          disabled={disabledBukaTransaksi.state}
          size="lg"
          onClick={(e) => handleClickBukaTransaksi(e)}
        />
      </>
    )
  } else {
    return <></>
  }
}

const ButtonActionUpdateTransaksi = ({
  formData,
  setFormData,
  setFormError,
  setShowModal,
}) => {
  const [disabledUpdateTransaksi, setDisabledUpdateTransaksi] = useState(
    SHOW_UPDATE_TRANSAKSI,
  )

  const handleClickUpdateTransaksi = async () => {
    setDisabledUpdateTransaksi(DISABLED_BUTTON_SUBMIT)
    try {
      const errors = validationInputRekapTagihan(formData)
      if (Object.keys(errors).length === 0) {
        const res = await instance3.post("/rekap-tagihan/update", {
          id_tagihan: parseInt(formData.rekap_tagihan_id),
          company_id: formData.company_id,
          instalasi_id: formData.jenis_rawat_id,
          penerima: formData.jenis_asuransi_id,
          asuransi_id: formData.asuransi_id,
          tanggal: toUTCFormat(formData.tanggal_rekap),
          tanggal_periode_awal: toUTCFormat(formData.tanggal_periode_awal),
          tanggal_periode_akhir: toUTCFormat(formData.tanggal_periode_akhir),
          tanggal_tagih: toUTCFormat(formData.tanggal_tagih),
          tanggal_jatuh_tempo: toUTCFormat(formData.tanggal_jatuh_tempo),
          no_resi: formData.no_resi,
        })

        if (res.data.status === 200) {
          defaultToastSuccess("Berhasil Memperbarui Data")
          setDisabledUpdateTransaksi(SHOW_BUKA_TRANSAKSI)
          setShowModal(false)
        } else {
          setDisabledUpdateTransaksi(SHOW_BUKA_TRANSAKSI)
          defaultToastError(res.data.message)
        }
      } else {
        scrollToTop()
        setFormError(errors)
        setDisabledUpdateTransaksi(SHOW_BUKA_TRANSAKSI)
        setShowModal(false)
      }
    } catch (error) {
      setDisabledUpdateTransaksi(SHOW_BUKA_TRANSAKSI)
      defaultToastError(error?.response?.data?.message)
    }
  }

  if (
    formData.status_proses === STATUS_TRANSAKSI_REAKP_TAGIHAN_BUKA ||
    formData.status_proses === STATUS_TRANSAKSI_REAKP_TAGIHAN_KUNCI
  ) {
    return (
      <>
        <MasterButton
          className={"mt-1 w-full text-center"}
          type={"button"}
          color={disabledUpdateTransaksi.color}
          name={disabledUpdateTransaksi.label}
          disabled={disabledUpdateTransaksi.state}
          size="lg"
          onClick={(e) => handleClickUpdateTransaksi(e)}
        />
      </>
    )
  } else {
    return <></>
  }
}

const ButtonActionBukaKembaliTransaksi = ({
  formData,
  setFormData,
  setFormError,
  setShowModal,
}) => {
  const [disabledBukaKembaliTransaksi, setDisabledBukaKembaliTransaksi] =
    useState(SHOW_BUKA_KUNCI_TRANSAKSI)

  const [showModalConfirm, setShowModalConfirm] = useState({
    state: false,
    type: "only-open",
  })

  const handleClickBukaKembaliTransaksi = async () => {
    setDisabledBukaKembaliTransaksi(DISABLED_BUTTON_SUBMIT)
    try {
      const errors = validationInputRekapTagihan(formData)
      if (Object.keys(errors).length === 0) {
        const res = await instance3.post("/rekap-tagihan/update-status", {
          id_tagihan: formData.rekap_tagihan_id,
          status_proses: STATUS_TRANSAKSI_REAKP_TAGIHAN_BUKA,
        })

        if (res.data.status === 200) {
          setFormData({
            ...formData,
            status_proses: STATUS_TRANSAKSI_REAKP_TAGIHAN_BUKA,
          })
          defaultToastSuccess("Berhasil Membuka Kunci Rekap Tagihan!")
          setDisabledBukaKembaliTransaksi(SHOW_BUKA_TRANSAKSI)
          setFormError(null)
        } else {
          setDisabledBukaKembaliTransaksi(SHOW_BUKA_KUNCI_TRANSAKSI)
          defaultToastError(res.data.message)
        }
        setShowModal(false)
      } else {
        scrollToTop()
        setFormError(errors)
        setDisabledBukaKembaliTransaksi(SHOW_BUKA_KUNCI_TRANSAKSI)
        setShowModal(false)
      }
    } catch (error) {
      setDisabledBukaKembaliTransaksi(SHOW_BUKA_KUNCI_TRANSAKSI)
      defaultToastError(error?.response?.data?.message)
    }
  }

  if (formData.status_proses === STATUS_TRANSAKSI_REAKP_TAGIHAN_KUNCI) {
    return (
      <>
        {showModalConfirm.state && (
          <ModalDeleteConfirm
            confirmHandle={(e) => {
              if (showModalConfirm.type === "only-open") {
                handleClickBukaKembaliTransaksi(e)
              } else {
                defaultToastError("TYPE NOT FOUND")
              }
            }}
            setShowModalDeleteConfirm={() =>
              setShowModalConfirm({
                state: false,
                type: "only-lock",
              })
            }
            labelConfirm="Ya, buka kunci rekap tagihan"
            msg="Apakah anda yakin membuka kunci rekap tagihan ini?"
            title="Konfirmasi Buka Kunci Rekap Tagihan"
          />
        )}

        <MasterButton
          className={"mt-1 w-full text-center"}
          type={"button"}
          color={disabledBukaKembaliTransaksi.color}
          name={disabledBukaKembaliTransaksi.label}
          disabled={disabledBukaKembaliTransaksi.state}
          size="lg"
          onClick={(e) =>
            setShowModalConfirm({
              type: "only-open",
              state: !showModalConfirm.state,
            })
          }
        />
      </>
    )
  } else {
    return <></>
  }
}

const ButtonActionKunciTransaksi = ({
  formData,
  setFormData,
  setShowModal,
  setFormError,
  rowsTagihan,
}) => {
  const [disabledKunciTransaksi, setDisabledKunciTransaksi] =
    useState(SHOW_KUNCI_TRANSAKSI)

  const [showModalConfirm, setShowModalConfirm] = useState({
    state: false,
    type: "only-lock",
  })

  const handleClickKunciTransaksi = async (e, force = false) => {
    setDisabledKunciTransaksi(DISABLED_BUTTON_SUBMIT)
    if (rowsTagihan.length > 0) {
      try {
        const res = await instance3.post("/rekap-tagihan/update-status", {
          id_tagihan: formData.rekap_tagihan_id,
          status_proses: STATUS_TRANSAKSI_REAKP_TAGIHAN_KUNCI,
        })
        if (res.data.status === 200) {
          setFormData({
            ...formData,
            status_proses: STATUS_TRANSAKSI_REAKP_TAGIHAN_KUNCI,
          })
          defaultToastSuccess(res.data.message)
          setDisabledKunciTransaksi(SHOW_KUNCI_TRANSAKSI)
          setShowModal(false)
          setFormError(null)
        } else {
          setDisabledKunciTransaksi(SHOW_KUNCI_TRANSAKSI)
          defaultToastError(res.data.message)
        }
      } catch (error) {
        setDisabledKunciTransaksi(SHOW_KUNCI_TRANSAKSI)
        defaultToastError(error?.response?.data?.message)
      }
    } else {
      setDisabledKunciTransaksi(SHOW_KUNCI_TRANSAKSI)
      defaultToastError("Harap pilih tagihan terlebih dahulu!")
      setShowModal(false)
      setFormError(null)
    }
  }

  if (formData.status_proses === STATUS_TRANSAKSI_REAKP_TAGIHAN_BUKA) {
    return (
      <>
        {showModalConfirm.state && (
          <ModalDeleteConfirm
            confirmHandle={(e) => {
              handleClickKunciTransaksi(e)
            }}
            setShowModalDeleteConfirm={() =>
              setShowModalConfirm({
                state: false,
                type: "only-lock",
              })
            }
            labelConfirm="Ya, kunci rekap tagihan"
            msg="Apakah anda yakin mengunci rekap tagihan ini? Kunci rekap tagihan tidak dapat dibuka kembali, setelah melakukan pembayaran"
            title="Konfirmasi Kunci Rekap Tagihan"
          />
        )}

        <MasterButton
          className={"mt-1 w-full text-center"}
          type={"button"}
          color={disabledKunciTransaksi.color}
          name={disabledKunciTransaksi.label}
          disabled={disabledKunciTransaksi.state}
          size="lg"
          onClick={(e) => {
            setShowModalConfirm({
              type: "only-lock",
              state: !showModalConfirm.state,
            })
          }}
        />
      </>
    )
  } else {
    return <></>
  }
}

const ButtonActionTutupTransaksi = ({
  formData,
  setFormData,
  setShowModal,
  setFormError,
  rowsPembayaran,
}) => {
  const [disabledTutupTransaksi, setDisabledTutupTransaksi] =
    useState(SHOW_TUTUP_TRANSAKSI)
  const [showModalConfirm, setShowModalConfirm] = useState({
    state: false,
    type: "only-close",
  })
  const [showModalConfirmTutup, setShowModalConfirmTutup] = useState({
    state: false,
    type: "only-close",
  })

  const handleClickTutupTransaksi = async () => {
    setDisabledTutupTransaksi(DISABLED_BUTTON_SUBMIT)
    try {
      const res = await instance3.post("/rekap-tagihan/update-status", {
        id_tagihan: formData.rekap_tagihan_id,
        status_proses: STATUS_TRANSAKSI_REAKP_TAGIHAN_TUTUP,
      })
      if (res.data.status === 200) {
        setFormData({
          ...formData,
          status_proses: STATUS_TRANSAKSI_REAKP_TAGIHAN_TUTUP,
        })
        defaultToastSuccess(res.data.message)
        setDisabledTutupTransaksi(SHOW_TUTUP_TRANSAKSI)
        setShowModal(false)
        setFormError(null)
      } else {
        setDisabledTutupTransaksi(SHOW_TUTUP_TRANSAKSI)
        defaultToastError(res.data.message)
      }
    } catch (error) {
      setDisabledTutupTransaksi(SHOW_TUTUP_TRANSAKSI)
      defaultToastError(error?.response?.data?.message)
    }
  }

  if (
    formData.status_proses === STATUS_TRANSAKSI_REAKP_TAGIHAN_KUNCI &&
    !isNull(formData.rekap_tagihan_id)
  ) {
    return (
      <>
        {showModalConfirm.state && (
          <ModalDeleteConfirm
            confirmHandle={(e) => {
              const dataPembayaran = rowsPembayaran.length
              if (dataPembayaran === 0) {
                setShowModalConfirm({
                  state: !showModalConfirm.state,
                  type: "only-close",
                })
                setShowModalConfirmTutup({
                  state: !showModalConfirmTutup.state,
                  type: "only-close",
                })
              } else {
                if (showModalConfirm.type === "only-close") {
                  handleClickTutupTransaksi(e)
                } else {
                  defaultToastError("TYPE NOT FOUND")
                }
              }
            }}
            setShowModalDeleteConfirm={() =>
              setShowModalConfirm({
                state: false,
                type: "only-close",
              })
            }
            labelConfirm="Ya, tutup rekap tagihan"
            msg="Apakah anda yakin mentutup rekap tagihan ini?"
            title="Konfirmasi Tutup Rekap Tagihan"
          />
        )}

        {showModalConfirmTutup.state && (
          <ModalDeleteConfirm
            confirmHandle={(e) => {
              if (showModalConfirm.type === "only-close") {
                handleClickTutupTransaksi(e)
              } else {
                defaultToastError("TYPE NOT FOUND")
              }
            }}
            setShowModalDeleteConfirm={() =>
              setShowModalConfirmTutup({
                state: false,
                type: "only-close",
              })
            }
            labelConfirm="Ya, tutup rekap tagihan"
            msg="Tidak ada pembayaran pada rekap tagihan ini, apakah anda yakin mentutup rekap tagihan ini?"
            title="Konfirmasi Tutup Rekap Tagihan Tanpa Pembayaran"
          />
        )}

        <MasterButton
          className={"mt-1 w-full text-center"}
          type={"button"}
          color={disabledTutupTransaksi.color}
          name={disabledTutupTransaksi.label}
          disabled={disabledTutupTransaksi.state}
          size="lg"
          onClick={(e) =>
            setShowModalConfirm({
              state: !showModalConfirm.state,
              type: "only-close",
            })
          }
        />
      </>
    )
  } else {
    return <></>
  }
}

const ButtonActionBukaTutupTransaksi = ({
  formData,
  setFormData,
  setFormError,
  setShowModal,
}) => {
  const [disabledBukaTutupTransaksi, setDisabledBukaTutupTransaksi] = useState(
    SHOW_BUKA_TUTUP_TRANSAKSI,
  )

  const [showModalConfirm, setShowModalConfirm] = useState({
    state: false,
    type: "only-open",
  })

  const handleClickBukaTutupTransaksi = async () => {
    setDisabledBukaTutupTransaksi(DISABLED_BUTTON_SUBMIT)
    try {
      const errors = validationInputRekapTagihan(formData)
      if (Object.keys(errors).length === 0) {
        const res = await instance3.post("/rekap-tagihan/update-status", {
          id_tagihan: formData.rekap_tagihan_id,
          status_proses: STATUS_TRANSAKSI_REAKP_TAGIHAN_KUNCI,
        })

        if (res.data.status === 200) {
          setFormData({
            ...formData,
            status_proses: STATUS_TRANSAKSI_REAKP_TAGIHAN_KUNCI,
          })
          defaultToastSuccess("Berhasil Membuka Kunci Rekap Tagihan!")
          setDisabledBukaTutupTransaksi(SHOW_BUKA_TUTUP_TRANSAKSI)
          setFormError(null)
        } else {
          setDisabledBukaTutupTransaksi(SHOW_BUKA_TUTUP_TRANSAKSI)
          defaultToastError(res.data.message)
        }
      } else {
        scrollToTop()
        setFormError(errors)
        setDisabledBukaTutupTransaksi(SHOW_BUKA_TUTUP_TRANSAKSI)
        setShowModal(false)
      }
    } catch (error) {
      setDisabledBukaTutupTransaksi(SHOW_BUKA_TUTUP_TRANSAKSI)
      defaultToastError(error?.response?.data?.message)
    }
  }

  if (
    formData.status_proses === STATUS_TRANSAKSI_REAKP_TAGIHAN_TUTUP &&
    !isNull(formData.rekap_tagihan_id)
  ) {
    return (
      <>
        {showModalConfirm.state && (
          <ModalDeleteConfirm
            confirmHandle={(e) => {
              if (showModalConfirm.type === "only-open") {
                handleClickBukaTutupTransaksi(e)
              } else {
                defaultToastError("TYPE NOT FOUND")
              }
            }}
            setShowModalDeleteConfirm={() =>
              setShowModalConfirm({
                state: false,
                type: "only-open",
              })
            }
            labelConfirm="Ya, buka kembali"
            msg="Apakah anda yakin membuka kembali rekap tagihan ini?"
            title="Konfirmasi Buka Tutup Rekap Tagihan"
          />
        )}

        <MasterButton
          className={"mt-1 w-full text-center"}
          type={"button"}
          color={disabledBukaTutupTransaksi.color}
          name={disabledBukaTutupTransaksi.label}
          disabled={disabledBukaTutupTransaksi.state}
          size="lg"
          onClick={(e) =>
            setShowModalConfirm({
              state: !showModalConfirm.state,
              type: "only-open",
            })
          }
        />
      </>
    )
  } else {
    return <></>
  }
}
